import { render, staticRenderFns } from "./led_screen.vue?vue&type=template&id=072503f1&scoped=true"
import script from "./led_screen.vue?vue&type=script&lang=js"
export * from "./led_screen.vue?vue&type=script&lang=js"
import style0 from "./led_screen.vue?vue&type=style&index=0&id=072503f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072503f1",
  null
  
)

export default component.exports